<template lang="pug">
  #docdoc
    h1 docs
</template>

<script type="text/babel">
  export default {

  }
</script>



// WEBPACK FOOTER //
// DocDoc.vue?65294a3a